import { useSyncExternalStore } from 'react';

/*
 * Whether the "not available in this demo" dialog is up. One dialog for the
 * whole app, so the nav, the settings tabs and the practice buttons all open
 * the same one.
 */
let open = false;
const listeners = new Set<() => void>();

function setOpen(next: boolean) {
  open = next;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function showDemoUnavailable() {
  setOpen(true);
}

export function hideDemoUnavailable() {
  setOpen(false);
}

export function useDemoUnavailableOpen(): boolean {
  return useSyncExternalStore(subscribe, () => open);
}
